import React from 'react'
import { useTenantlessApiContext } from '../components/App/AppApi'
import EqxButton from '../shared/components/EqxButton/EqxButton'

interface PageGetTenantProps { }
const PageGetTenant = function (props: PageGetTenantProps) {
    const [error, setError] = React.useState<string | undefined>(undefined)
    const api = useTenantlessApiContext()
    React.useEffect(() => {
        //change body class - remove any that start with page-* and add page-login
        document.body.className = document.body.className.replace(/\bpage-\S+/g, '')
        document.body.classList.add('page-login')

        return () => {
            document.body.className = document.body.className.replace(/\bpage-\S+/g, '')
        }
    }, [])
    const onSubmitClick = () => {
        const tenantID = document.querySelector('input[name="tenantID"]') as HTMLInputElement
        setError(undefined)
        return api.endpoints
            .tenantById(tenantID.value.toUpperCase())
            .execute(api)
            .then(function () {
                window.location.href = `/${tenantID.value}`
            })
            .catch(function () {
                setError("Couldn't find that customer, sorry")
            })
    }
    return (
        <div id="login-container">
            <div id="login-outer-title">Continuum-BI</div>
            <div id="login">
                <div id="login-header">
                    <img src="/images/logo-no-text.svg" alt="Continuum-BI" id="login-logo" />
                    <img src="/images/logo-text.svg" alt="" id="login-logo-text" style={{ height: '20px' }} />
                </div>
                <div id="login-body">
                    {error && (
                        <div className="alert alert-danger text-start" role="alert">
                            {error}
                        </div>
                    )}
                    <span className="input-group">
                        <input
                            type="text"
                            className={'form-control ' + (error ? 'is-invalid' : '')}
                            name="tenantID"
                            placeholder="Equinoxx Customer ID"
                        />
                        <EqxButton onClick={onSubmitClick} variant="primary" text="Go" />
                    </span>
                </div>
            </div>
        </div>
    )
}
export default PageGetTenant
